import { IUser } from './Interfaces';

export interface IUserState {
    user: IUser;
}

export const initialUserState = {
    selectedUser: {
        id: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        iconUrl: null,
    },
};
